import { useEffect, useRef } from 'react'

// Longest overlay exit transition (Drawer: 450ms) plus a scheduling buffer.
const EXIT_UNMOUNT_FAILSAFE_MS = 800

// Base UI unmounts a closed popup only when its exit transition reports
// finishing. If the transition is cancelled mid-flight — e.g. React hides the
// tree with `display: none` when a Suspense boundary above us shows its
// fallback during a route change — that report never comes and the closed
// overlay stays mounted forever, its invisible backdrop swallowing all clicks.
// Force-unmount once the exit transition should long be over.
export function useOverlayUnmountFailsafe(
  open: boolean,
  actionsRef: React.RefObject<{ unmount: () => void } | null>
) {
  const wasOpenRef = useRef(false)

  useEffect(() => {
    if (open) {
      wasOpenRef.current = true
      return undefined
    }
    if (!wasOpenRef.current) {
      return undefined
    }
    const timeout = setTimeout(
      () => actionsRef.current?.unmount(),
      EXIT_UNMOUNT_FAILSAFE_MS
    )
    return () => clearTimeout(timeout)
  }, [open, actionsRef])
}
